import React from 'react';
import './Modal.css';
import ButtonExit from '../Icons/ButtonExit'

const Modal = (props) => (
  <div className={`modal-wrapper ${props.isOpen ? 'visible' : ''}`}>
    <div
      className={`overlay ${props.isOpen ? 'visible' : ''}`}
      onClick={props.onExit}
    />
   

    <div className='modal-content'>
    
      <div className='modal-body'>{props.children}</div>
      <ButtonExit onClick={props.onExit} className='exit-button'></ButtonExit>
    </div>
  </div>
);

export default Modal;
